export const getWeekNumber = () => {
  return {
    method: 'GET',
    url: `${process.env.REACT_APP_ORIGIN}/week/week-number`,
  }
}
